import styled from 'astroturf/react';
import Svg from 'components/Svg';

const ColumnPopup = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  top: 36px;
  box-shadow: var(--ph-box-shadow-sm);
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  padding: 13px;
  cursor: default;
  min-width: 250px;
`;

const ColumnSort = styled('div')`
  transition: var(--ph-transition);
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 35px;
  letter-spacing: normal;
  color: var(--black);
  cursor: pointer;
  position: relative;

  &:hover {
    border-radius: var(--ph-border-radius-sm);
    background-color: rgba(var(--ph-gray-rgb-50), 0.8);
  }

  path {
    fill: var(--black);
  }

  &.hasActive {
    color: var(--black);
  }

  &.active {
    cursor: default;
    background-color: rgba(var(--ph-gray-rgb-50), 0.8);
    color: var(--black);

    path {
      fill: var(--black);
    }
  }
`;

const ColumnSortIcon = styled(Svg)`
  width: 13px;
  margin: 0 10px 0 15px;
`;

const FiltersWrapper = styled('div')`
  margin: 0 -3px;
  padding: 0 5px;

  label[class*='Checkbox'] {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const FiltersHeader = styled('div')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  color: var(--black);
  margin: 10px 10px 0;
`;

export default {
  ColumnPopup,
  ColumnSort,
  FiltersWrapper,
  FiltersHeader,
  ColumnSortIcon,
};
